import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import "./What_our_users_say.css";

// Example data (replace with your real images)
const users = [
    {
        id: 1,
        name: "Vaishnavi Raut",
        img: "./assets/images/home/what_our_user_say/Vaishnavi_Raut.png",
        text: "I’ve tried many recharge apps, but this one is the easiest to use. I can recharge my mobile or pay bills in just a few taps, and instant confirmations give me peace of mind. Highly recommended!",
    },
    {
        id: 2,
        name: "Rohit Sharma",
        img: "./assets/images/home/what_our_user_say/Rohit_sharma.png",
        text: "Super fast transactions and great cashback offers. It has become my go-to app for all payments!",
    },
    {
        id: 3,
        name: "Aditi Patel",
        img: "./assets/images/home/what_our_user_say/Aditi_patil.png",
        text: "The UI is smooth, and I love how everything is organized. Recharges are done in seconds!",
    },
];

function What_our_users_say() {
    const [current, setCurrent] = useState(0);
    const [transition, setTransition] = useState(false);

    const nextSlide = () => {
        setTransition(true);
        setTimeout(() => {
            setCurrent((prev) => (prev + 1) % users.length);
            setTransition(false);
        }, 400);
    };

    const prevSlide = () => {
        setTransition(true);
        setTimeout(() => {
            setCurrent((prev) => (prev - 1 + users.length) % users.length);
            setTransition(false);
        }, 400);
    };

    const mainUser = users[current];
    const nextUser = users[(current + 1) % users.length];
    const prevUser = users[(current + 2) % users.length];

    return (
        <section className="What_our_users_say section_margin">
            <div className="container">
                <div className="row align-items-center">
                    {/* Left heading */}
                    <div className="col-xl-3 col-md-12">
                        <div className="heading_text_holder">
                            <div className="quote_img_holder ">
                                <img src="./assets/images/home/what_our_user_say/quote.png" alt="" className="quote_img" />
                            </div>
                            <h4>What Our Users Say</h4>
                            <p>
                                Hear from real users who enjoy fast, secure, and hassle-free
                                recharges every day.
                            </p>
                        </div>

                        <div className="navigation_holder">
                            <div className="arrow_btn" onClick={prevSlide}>
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </div>
                            <div className="arrow_btn" onClick={nextSlide}>
                                <FontAwesomeIcon icon={faAngleRight} />
                            </div>
                        </div>
                    </div>

                    {/* Right testimonial area */}
                    <div className="col-xl-9 col-md-12">
                        <div className={`row  slider-container ${transition ? "slide" : ""}`}>
                            <div className="col-md-8 col-sm-8 ">
                                <div className="What_our_users_say_card">
                                    <div className="row ">
                                        <div className="col-md-4 col-sm-3 col-6">
                                            <div className="user_img_holder slider_1">
                                                <img src={mainUser.img} alt={mainUser.name} className="user_img" />
                                            </div>
                                        </div>
                                        <div className="col-md-8 col-sm-9 ">
                                            <div className="text_holder">
                                                <div>
                                                    <h6>{mainUser.name}</h6>
                                                    <p>"{mainUser.text}"</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Side user images */}
                            <div className="col-md-2 col-sm-2 col-6">
                                <div className="side_user_img_holder slider_2">
                                    <img src={nextUser.img} alt={nextUser.name} className="user_img" />
                                </div>
                            </div>

                            <div className="col-md-2 col-sm-2 col-6">
                                <div className="side_user_img_holder slider_3">
                                    <img src={prevUser.img} alt={prevUser.name} className="user_img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default What_our_users_say;
